var map = {
	"./": [
		43803
	],
	"./arabic": [
		61263,
		1263
	],
	"./arabic.ts": [
		61263,
		1263
	],
	"./burmese": [
		36996,
		6996
	],
	"./burmese.ts": [
		36996,
		6996
	],
	"./gahuza": [
		36405,
		6405
	],
	"./gahuza.ts": [
		36405,
		6405
	],
	"./hausa": [
		59741,
		9741
	],
	"./hausa.ts": [
		59741,
		9741
	],
	"./hindi": [
		37935,
		7935
	],
	"./hindi.ts": [
		37935,
		7935
	],
	"./index": [
		43803
	],
	"./index.test": [
		23441,
		3441
	],
	"./index.test.ts": [
		23441,
		3441
	],
	"./index.ts": [
		43803
	],
	"./indonesia": [
		64313,
		4313
	],
	"./indonesia.ts": [
		64313,
		4313
	],
	"./kyrgyz": [
		80003,
		3
	],
	"./kyrgyz.ts": [
		80003,
		3
	],
	"./marathi": [
		49649,
		9649
	],
	"./marathi.ts": [
		49649,
		9649
	],
	"./nepali": [
		35578,
		5578
	],
	"./nepali.ts": [
		35578,
		5578
	],
	"./persian": [
		36523,
		6523
	],
	"./persian.ts": [
		36523,
		6523
	],
	"./portuguese": [
		70102,
		102
	],
	"./portuguese.ts": [
		70102,
		102
	],
	"./russian": [
		43006,
		3006
	],
	"./russian.ts": [
		43006,
		3006
	],
	"./tamil": [
		19244,
		9244
	],
	"./tamil.ts": [
		19244,
		9244
	],
	"./types": [
		92350,
		2350
	],
	"./types.ts": [
		92350,
		2350
	],
	"./ukrainian": [
		56197,
		6197
	],
	"./ukrainian.ts": [
		56197,
		6197
	],
	"./urdu": [
		52735,
		2735
	],
	"./urdu.ts": [
		52735,
		2735
	],
	"./zhongwen": [
		18581,
		8581
	],
	"./zhongwen.ts": [
		18581,
		8581
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 36219;
module.exports = webpackAsyncContext;